import React, { useState } from 'react';

function ColorPicker({ colorData, currentColor, onSelect }) {
    const [selectedColor, setSelectedColor] = useState(0);
    const [expanded, setExpanded] = useState(false);
    const maxVisibleColors = 12;

    const handleColorSelect = (index) => {
        setSelectedColor(index);
        const selectedRgba = colorData[index].rgba;
        onSelect(selectedRgba);
    };

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    return (
        <div className="flex flex-col items-center p-6 space-y-6">
            <h1 className="text-lg text-gray-900 font-bold mb-4 font-inter">Choose a shade of {currentColor}</h1>
            <div className={`grid ${expanded ? 'grid-cols-5' : 'grid-cols-4 md:grid-cols-5'} gap-4`}>
                {colorData.slice(0, expanded ? colorData.length : maxVisibleColors).map((color, index) => (
                    <div
                        key={index}
                        className={`w-12 h-12 rounded-lg ${selectedColor === index ? 'ring-2 ring-black' : 'ring-2 ring-transparent'} transition-all cursor-pointer`}
                        style={{ backgroundColor: `rgba(${color.rgba})` }}
                        onClick={() => handleColorSelect(index)}
                    ></div>
                ))}
            </div>
            {colorData.length > maxVisibleColors && (
                <button onClick={toggleExpanded} className="flex items-center mt-4 space-x-2">
                    <span>{expanded ? 'Hide all colors' : 'Show more shades'}</span>
                    <svg className={`h-5 w-5 transform transition-transform ${expanded ? 'rotate-180' : ''}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </button>
            )}
        </div>
    );
}

export default ColorPicker;
